export enum FilterScore {
  Full    = 1,
  Partial = 0,
  NoInfo  = -1
}
